// extracted by mini-css-extract-plugin
export default {"modalBody":"SignUpVk_modalBody__kaWjn","modalMessage":"SignUpVk_modalMessage__BDC7p","card":"SignUpVk_card__cwQCq"};